import { getCookie, setCookie } from "tiny-cookie";

window.cookieBanner = function() {
  return {
    cookiesIsOK: true,
    hideBanner() {
      setCookie("cookiebanner", 5, { expires: "365D" });
      this.cookiesIsOK = true;
    },
    mounted() {
      if (getCookie("cookiebanner") == "5") {
        this.cookiesIsOK = true;
      } else {
        console.log("FALSE!");
        this.cookiesIsOK = false;
      }
    },
  };
};
